module.exports = __webpack_public_path__ + "img/logo.7b6cb2b5.png";